module.exports = __webpack_public_path__ + "static/img/1.9bd0389.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/1.png
// module id = b0Nb
// module chunks = 0